import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useCompany, useDisableCustomer } from '@/services/api/hooks/companies';

import { FunctionComponent, Suspense } from 'react';
import { toast } from 'sonner';

const DisableCustomerModal: FunctionComponent<ModalProps<{ mspId: string; customerId: string }>> = props => {
  const DisableCustomer = () => {
    const mspId = props.props?.mspId;
    if (!mspId) throw new Error('Missing partner id');
    if (!props.props?.customerId) throw new Error('Missing company id');

    const [customer] = useCompany(mspId, props.props?.customerId);
    const disableCustomer = useDisableCustomer();
    const onDisable = async () => {
      await disableCustomer.mutateAsync({
        partnerId: mspId,
        id: customer.id
      });
      props.close();
      toast.success(`${customer.name} disabled`);
    };

    return (
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Disable customer</h1>
        </Modal.Controls>

        <div className="space-y-2">
          <p className="text-lg">
            Are you sure you want to disable: <span className="font-semibold">{customer.name}?</span>
          </p>

          <div className="flex gap-2 justify-end">
            <Button className="flex-1" onClick={props.close}>
              Cancel
            </Button>
            <Button
              type="button"
              className="flex-1"
              variant={ButtonVariant.Destructive}
              loading={disableCustomer.isLoading}
              onClick={onDisable}
            >
              Disable
            </Button>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <DisableCustomer />
      </Suspense>
    </Modal>
  );
};

export default DisableCustomerModal;
